import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({ description, lang, meta, keywords, title, image, canonicalUrl, nextUrl, prevUrl }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `,
  );

  if (!title) {
    title = 'Allt om e-handel';
  }
  const metaDescription = description ? description : 'På vår blogg kan du läsa om de senaste trenderna inom e-handel';

  const extraTags = [];
  if (image) {
    extraTags.push({
      property: `og:image`,
      content: 'https://commercemind.se' + image,
    });
    extraTags.push({
      property: `twitter:image`,
      content: 'https://commercemind.se' + image,
    });
  }

  const links = [];

  links.push({ rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' });
  links.push({ rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' });
  links.push({ rel: 'manifest', href: '/site.webmanifest.json' });

  if (canonicalUrl) {
    links.push({ rel: 'canonical', href: canonicalUrl });
  }
  if (nextUrl) {
    links.push({ rel: 'next', href: nextUrl });
  }
  if (prevUrl) {
    links.push({ rel: 'prev', href: prevUrl });
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={links}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        ...extraTags,
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : [],
        )
        .concat(meta)}
    ></Helmet>
  );
};

SEO.defaultProps = {
  lang: 'sv',
  meta: [],
  keywords: [],
};

export default SEO;
